import { useEffect, useState } from 'react';

export const usePercentageConverter = (value: number, maxValue: number) => {
    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        if (maxValue <= 0) {
            console.error('Max value should be greater than 0');
            return;
        }

        const calculatedPercentage = (value / maxValue) * 100;
        setPercentage(calculatedPercentage);
    }, [value, maxValue]);

    return percentage;
};
